"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWebSocket = void 0;
var react_1 = require("react");
var WEBSOCKET_EVENTS = {
    CLOSE: 'close',
    ERROR: 'error',
    OPEN: 'open',
    MESSAGE: 'message'
};
var useWebSocket = function () {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    var _a = __read((0, react_1.useState)(false), 2), isError = _a[0], setIsError = _a[1];
    var _b = __read((0, react_1.useState)(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var _c = __read((0, react_1.useState)(), 2), message = _c[0], setMessage = _c[1];
    var _d = __read((0, react_1.useState)(), 2), socket = _d[0], setSocket = _d[1];
    (0, react_1.useEffect)(function () {
        if (!isOpen) {
            setIsError(false);
            var socket_1 = new (WebSocket.bind.apply(WebSocket, __spreadArray([void 0], __read(params), false)))();
            setSocket(socket_1);
        }
    }, [isOpen]);
    (0, react_1.useEffect)(function () {
        if (socket)
            socket.addEventListener(WEBSOCKET_EVENTS.OPEN, function () { return setIsOpen(true); });
        return function () { return socket === null || socket === void 0 ? void 0 : socket.removeEventListener(WEBSOCKET_EVENTS.OPEN, function () { return setIsOpen(true); }); };
    }, [socket]);
    (0, react_1.useEffect)(function () {
        if (socket)
            socket.addEventListener(WEBSOCKET_EVENTS.CLOSE, function () { return setIsOpen(false); });
        return function () { return socket === null || socket === void 0 ? void 0 : socket.removeEventListener(WEBSOCKET_EVENTS.CLOSE, function () { return setIsOpen(false); }); };
    }, [socket]);
    (0, react_1.useEffect)(function () {
        if (socket)
            socket.addEventListener(WEBSOCKET_EVENTS.MESSAGE, function (e) { return setMessage(e.data); });
        return function () { return socket === null || socket === void 0 ? void 0 : socket.removeEventListener(WEBSOCKET_EVENTS.MESSAGE, function (e) { return setMessage(e.data); }); };
    }, [socket]);
    (0, react_1.useEffect)(function () {
        if (socket)
            socket.addEventListener(WEBSOCKET_EVENTS.ERROR, function () { return setIsError(true); });
        return function () { return socket === null || socket === void 0 ? void 0 : socket.removeEventListener(WEBSOCKET_EVENTS.ERROR, function () { return setIsError(true); }); };
    }, [socket]);
    return { isError: isError, isOpen: isOpen, message: message, socket: socket };
};
exports.useWebSocket = useWebSocket;
//# sourceMappingURL=index.js.map